import React, { FC, useState } from 'react';

import { Icon } from '@iconify/react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import LoadingButton from '~/components/atoms/buttons/LoadingButton';
import projectConfig, { PROJECT } from '~/projects/config';

import { ReactComponent as SidekickerIcon } from './rocket.svg';
import styles from './styles.module.scss';

type Props = {
  onClick: () => Promise<void>;
};

const ButtonIconConfig: Record<PROJECT, FC> = {
  [PROJECT.JUSTDONE]: () => (
    <Icon icon="material-symbols:bolt-outline" color="#FFE86C" />
  ),
  [PROJECT.SIDEKICKER]: () => <SidekickerIcon />,
};

const ButtonIcon = ButtonIconConfig[projectConfig.project];

const UpgradeNowButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (): Promise<void> => {
    try {
      setIsLoading(true);
      await onClick();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoadingButton
      disabled={isLoading}
      loading={isLoading}
      fullWidth
      startIcon={<ButtonIcon />}
      onClick={handleClick}
      className={clsx(styles.button, {
        [styles['button--justdone']]:
          projectConfig.project === PROJECT.JUSTDONE,
        [styles['button--sidekicker']]:
          projectConfig.project === PROJECT.SIDEKICKER,
      })}
    >
      {t('upgrade_now', 'Upgrade Now')}
    </LoadingButton>
  );
};

export default UpgradeNowButton;
